<script setup lang="ts">
import {
  CardEditor,
  type ICardEditorProps,
  type IOrganization
} from "@frontiers-vue3/public-pages";
import type { IAuthor } from "~/types";

const props = withDefaults(defineProps<IAuthor>(), {
  affiliations: () => []
});

const runtimeConfig = useRuntimeConfig();

const affiliationMapped = computed((): IOrganization | undefined => {
  if (!props.affiliations.length) return undefined;

  return {
    name: props.affiliations[0].organization,
    city: props.affiliations[0].city || "",
    country: props.affiliations[0].country || ""
  };
});

const authorMapped = computed((): ICardEditorProps => {
  const { loopUrl, capitalizedEditorCardNames } = runtimeConfig.public;
  return {
    id: String(props.userId),
    profileImageUrl: `${loopUrl}/images/profile/${props.userId}/55`,
    fullName: props.fullName,
    affiliation: affiliationMapped.value,
    capitalizeName:
      capitalizedEditorCardNames.toString() === "true" ? true : false
  };
});
</script>

<template>
  <CardEditor v-bind="authorMapped" />
</template>

<style lang="scss">
.CardEditor {
  height: 100%;
}
</style>
